// Fechar

import { empty, from, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { get } from 'lodash';
import { Injectable } from '@angular/core';

import { Action } from '@core/components/actions/action.default';
import { getValue } from '@app/shared/utils/feature-utils';
import { UserService } from '@services-api/user.service';
import { HttpClient } from '@angular/common/http';
import { FeatureService } from '@services/feature/feature.service';
import { MessagesService } from '@services/messages/message.service';
import { ConditionEvaluatorService } from '@services/condition-evaluator/condition-evaluator.service';
import { environment } from '@env/environment';
const BASE_PATH = environment.basePath;

@Injectable()
export class FecharAction extends Action {

	constructor(
    private featureService: FeatureService,
private httpClient: HttpClient,
private service: UserService,

        private conditionEvaluator: ConditionEvaluatorService,
        private message: MessagesService) {
    super();
  }
  /**
  * Pre execute step to validate the form
  * @param {object} context - The component's controler
  * @returns {Observable}
  */
  preExecute(params): Observable<any> {
   return of(params);
 }
  /**
  * Execute the action
  * @param {object} context - The component's controler
  * @returns {Observable}
  */
  execute(context): Observable<any>{
    
  throw new Error('action Fechar has no API to request');
  }

  postExecute(params): Observable<any> {
    return of(params);
  }
}

